import React from "react";
import { Button } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { CategoryCard } from "./CategoryCard";
import { GroupedQuestion } from "./types";

type InitialViewProps = {
  categories: GroupedQuestion[];
  onCategoryClick: (categoryKey: string) => void;
  onExploreMore: () => void;
};

export const InitialView = ({
  categories,
  onCategoryClick,
  onExploreMore,
}: InitialViewProps) => (
  <div className="flex flex-col gap-3 items-center mt-9">
    <div className="flex gap-3">
      {categories.slice(0, 3).map((category) => (
        <CategoryCard
          key={category.key}
          category={category}
          onClick={onCategoryClick}
        />
      ))}
    </div>
    <Button
      type="text"
      onClick={onExploreMore}
      icon={<DownOutlined />}
      iconPlacement="end"
      className="text-[#064C68] font-semibold"
    >
      Explore more use cases
    </Button>
  </div>
);
